import React from "react";

const SubsidyProgram = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Manner of Execution of Subsidy Programme</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <ol>
          <li className="mb-2">
            It is informed that seed distribution subsidy is admissible on the
            sale of certified seeds of i.e. Kharif and Rabi crops, which is
            provided by Agriculture & Farmers welfare Department, Haryana,
            Panchkula.{" "}
          </li>
          <li className="mb-2">
            <p>The rate of crop wise subsidy is as under:-</p>
            <p>(Rate per Qtl.)</p>
            <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Crops</th>
                  <th>Name of Scheme</th>
                  <th>Rate of Subsidy</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2">1</td>
                  <td rowspan="2">Pulses</td>
                  <td rowspan="2">NFSM (Pulses)</td>
                  <td>5000/-</td>
                  <td>Varieties less than 10 years.</td>
                </tr>
                <tr>
                  <td>2500/-</td>
                  <td>Varieties more than 10 years.</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Paddy</td>
                  <td>RKVY & State Plan</td>
                  <td>1000/-</td>
                  <td>Varieties not older than 10 years.</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Bajra</td>
                  <td>RKVY & State Plan</td>
                  <td>1500/-</td>
                  <td>Varieties not older than 10 years.</td>
                </tr>
                <tr>
                  <td rowspan="2">4</td>
                  <td rowspan="2">Lentil</td>
                  <td rowspan="2">NFSM (Pulses)</td>
                  <td>5000/-</td>
                  <td>Varieties less than 10 years.</td>
                </tr>
                <tr>
                  <td>2500/-</td>
                  <td>Varieties more than 10 years.</td>
                </tr>
                <tr>
                  <td rowspan="2">5</td>
                  <td rowspan="2">Gram</td>
                  <td rowspan="2">NFSM (Pulses)</td>
                  <td>5000/-</td>
                  <td>Varieties less than 10 years.</td>
                </tr>
                <tr>
                  <td>2500/-</td>
                  <td>Varieties more than 10 years.</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Mustard</td>
                  <td>NFSM - OS & OP</td>
                  <td>4000/-</td>
                  <td>Varieties less than 10 years.</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Barley</td>
                  <td>RKVY AFTAAR & State Plan Scheme</td>
                  <td>1500/-</td>
                  <td>Distribution of Certified seed less than 10 year old.</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Wheat</td>
                  <td>RKVY AFTAAR & State Plan Scheme</td>
                  <td>1000/-</td>
                  <td>Distribution of Certified seed less than 10 year old.</td>
                </tr>
              </tbody>
            </table>
            </div>
          </li>
          <li className="mb-2">
            As & when the information regarding subsidy announced on
            distribution of certified seeds, the amount of subsidy deducted from
            the full sale rate of the crops fixed by HSDC and the seed is
            provided to the farmers of the state through HSDC sale counters on
            net subsidized sale rate during Kharif and Rabi sale season.
          </li>
          <li className="mb-2">
            The proper record for sale of certified seed at HSDC sale counters
            maintained in the duplicate copy.
          </li>
          <li className="mb-2">
            After end of the sale season, HSDC claim subsidy amount from the
            concerned DDA's of the Agriculture & Farmers welfare Department on
            produce of the relevant records.
          </li>
        </ol>

       
      </div>
    </div>
  );
};

export default SubsidyProgram;
